<template>
  <ul>
    <component
      :is="resolveNavItemComponent(item)"
      v-for="item in filteredItems"
      :key="item.header || item.title"
      :item="item"
    />
  </ul>
</template>

<script>
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from "@core/layouts/utils";
import { provide, ref } from "@vue/composition-api";
import VerticalNavMenuHeader from "../vertical-nav-menu-header";
import VerticalNavMenuLink from "../vertical-nav-menu-link/VerticalNavMenuLink.vue";
import VerticalNavMenuGroup from "../vertical-nav-menu-group/VerticalNavMenuGroup.vue";

export default {
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    filteredItems() {
      const filterItems = (items) => {
        return items
          .filter((item) => {
            // If the item doesn't have a permission defined, display it by default
            if (!item.permission) return true;
            // Check if the user has permission using $can
            if (Array.isArray(item.permission)) {
              return item.permission.some((permission) =>
                this.$can(permission)
              );
            } else {
              return this.$can(item.permission);
            }
          })
          .map((item) => ({
            ...item,
            children: item.children
              ? filterItems(item.children)
              : item.children,
          }));
      };
      return filterItems(this.items);
    },
  },
  setup() {
    provide("openGroups", ref([]));

    return {
      resolveNavItemComponent,
    };
  },
};
</script>
